import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  AppTokenService,
  SessionService,
  UserDataService
} from '@com-delta-idp/mnx-oauth';
import {
  CommonConstants,
  EndpointKeys,
  IDP_APPS,
  Libraries
} from '@com-delta-idp/mnx-skymiles-shared';
import {
  ApiBuilder,
  AppConfigService,
  handleError,
  HttpHeadersPayload,
  HttpRequestMethods
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BusinessTravelerPayload, BusinessTravelerResponse } from '../models';
import { BUSINESS_TRAVELER_QUERY } from '../models/business-traveler.constants';

@Injectable({
  providedIn: 'root'
})
export class DataHelperService {
  errorHandler = handleError.bind(this);

  http = inject(HttpClient);
  appConfig = inject(AppConfigService);
  session = inject(SessionService);
  appToken = inject(AppTokenService);
  userData = inject(UserDataService);

  createBusinessTravelerRequest(
    headers: HttpHeadersPayload
  ): Observable<boolean> {
    return new ApiBuilder<BusinessTravelerPayload, BusinessTravelerResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.SKYMILES)
      .endpointKey(
        EndpointKeys['SKYMILES_API_BUSINESS_TRAVELER_CUSTOMER_PROFILE']
      )
      .method(HttpRequestMethods['POST'])
      .payload({ query: BUSINESS_TRAVELER_QUERY })
      .httpHeaders(headers)
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(Libraries.LANDING_PAGE)
      .create()
      .pipe(
        map((response: BusinessTravelerResponse) => {
          return !!response?.data?.loyalty_program?.loyaltyMemberAccount
            ?.loyaltyMemberEligibility?.deltaBusinessTraveler;
        })
      );
  }
}
